import React, { useState } from 'react';
import { Star, Send, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import api from '@/services/api';

const AvaliacaoEntrega = ({ entrega, clienteId, onClose, onSuccess }) => {
  const [estrelas, setEstrelas] = useState(0);
  const [hoverEstrelas, setHoverEstrelas] = useState(0);
  const [comentario, setComentario] = useState('');
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async () => {
    if (estrelas === 0) {
      toast.error('Selecione uma avaliação de 1 a 5 estrelas');
      return;
    }
    
    setLoading(true);
    try {
      await api.post(`/avaliacoes/entrega?cliente_id=${clienteId}`, {
        entrega_id: entrega.id,
        estrelas,
        comentario: comentario.trim() || null
      });
      
      toast.success('Avaliação enviada com sucesso!');
      onSuccess?.();
      onClose?.();
    } catch (error) {
      console.error('Erro ao enviar avaliação:', error);
      toast.error(error.response?.data?.detail || 'Erro ao enviar avaliação');
    } finally {
      setLoading(false);
    }
  };
  
  const getEstrelaLabel = (valor) => {
    const labels = {
      1: 'Péssimo',
      2: 'Ruim',
      3: 'Regular',
      4: 'Bom',
      5: 'Excelente'
    };
    return labels[valor] || '';
  };
  
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-gray-900">Avaliar Entrega</h2>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        
        {/* Info da entrega */}
        <div className="bg-gray-50 rounded-xl p-4 mb-6">
          <p className="text-sm text-gray-500">Entrega #{entrega?.id?.slice(-6)}</p>
          <p className="font-medium text-gray-900">{entrega?.destino_endereco}</p>
        </div>
        
        {/* Estrelas */}
        <div className="text-center mb-6">
          <p className="text-sm text-gray-600 mb-3">Como foi a entrega?</p>
          
          <div className="flex justify-center gap-2 mb-2">
            {[1, 2, 3, 4, 5].map((valor) => (
              <button
                key={valor}
                onClick={() => setEstrelas(valor)}
                onMouseEnter={() => setHoverEstrelas(valor)}
                onMouseLeave={() => setHoverEstrelas(0)}
                className="p-1 transition-transform hover:scale-110"
              >
                <Star 
                  className={`w-10 h-10 transition-colors ${
                    valor <= (hoverEstrelas || estrelas)
                      ? 'text-yellow-400 fill-yellow-400'
                      : 'text-gray-300'
                  }`}
                />
              </button>
            ))}
          </div>
          
          <p className={`text-lg font-medium transition-all ${
            estrelas > 0 ? 'text-gray-900' : 'text-gray-400'
          }`}>
            {estrelas > 0 ? getEstrelaLabel(estrelas) : 'Toque para avaliar'}
          </p>
          
          {estrelas <= 2 && estrelas > 0 && (
            <p className="text-xs text-red-500 mt-2">
              Avaliações de 1-2 estrelas são consideradas reclamações
            </p>
          )}
        </div>
        
        {/* Comentário */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Comentário (opcional)
          </label>
          <textarea
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
            placeholder="Conte como foi sua experiência..."
            rows={3}
            className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none resize-none"
          />
        </div>
        
        {/* Botões */}
        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={loading || estrelas === 0}
            className="flex-1 bg-orange-600 hover:bg-orange-700"
          >
            {loading ? (
              'Enviando...'
            ) : (
              <>
                <Send className="w-4 h-4 mr-2" />
                Enviar Avaliação
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AvaliacaoEntrega;
